<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  changePsw,
} from 'api/user';
import pageDataMixin from '@qx/mixin/pageData';
import { removeToken, removeUserInfo } from '@qx/utils/auth';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/other/changePsw',
      formComponents: ['baseForm'],
    };
  },
  methods: {
    editApi: changePsw,
    handleSubSucc () {
      this.$message.success('修改成功');
      removeToken();
      removeUserInfo();
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
